@value tablet from "@shared/styles/breakpoints.module.css";

.root {
  min-width: 0;
  margin-top: var(--space-40);
}

.title {
  margin: 0 0 var(--space-24);
  padding-bottom: var(--space-20);
  border-bottom: 1px solid var(--color-border);
  font-family: var(--font-heading);
  font-size: var(--type-project);
  font-weight: 600;
  text-transform: none;
  letter-spacing: normal;
  line-height: 1.2;
  color: var(--color-text);
}

.list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-32) var(--space-48);
  margin: 0;
  padding: 0;
  list-style: none;

  @media (max-width: tablet) {
    grid-template-columns: minmax(0, 1fr);
  }
}

.item {
  min-width: 0;
}

.itemTitle {
  margin: 0 0 var(--space-8);
  font-family: var(--font-heading);
  font-size: var(--type-catalog);
  font-weight: 600;
  text-transform: none;
  letter-spacing: normal;
  line-height: 1.3;
  color: var(--color-text);
  text-wrap: pretty;
}

.link {
  color: var(--color-primary);
  text-decoration-thickness: 1px;
  text-underline-offset: var(--space-3);
}

.description {
  margin: 0;
  font-size: var(--type-body);
  line-height: 1.65;
  color: var(--color-text-muted);
}
